<div
  *ngIf="
    (product.estoque > 0 || !validaEstoque) &&
    product.sku &&
    pedidoService.pedido &&
    pedidoService.pedido.clientes.length === 1
  "
  class="row mt-1 mb-1"
>
  <div
    class="input-group col-xl-6 col-lg-6 col-md-6 col-sm-6 col-7"
    style="padding-left: 0px !important"
    [style.max-width]="'145px'"
  >
    <a
      [class.errorForm]="error"
      [style.color]="theme.color"
      [style.border-color]="theme.color"
      class="noselect quantity-button-minus {{ inputClass }}"
      (click)="less(product.multiplo)"
      >-
    </a>
    <div class="quantity-input-box">
      <input
        [class.errorForm]="error"
        [style.color]="theme.color"
        [style.border-color]="theme.color"
        [value]="quantity"
        type="number"
        (keyup)="setQuantity($event)"
        (keyup.enter)="addCart()"
        class="form-control quantity-input {{ inputClass }}"
        min="0"
      />
    </div>
    <a
      [class.errorForm]="error"
      [style.color]="theme.color"
      [style.border-color]="theme.color"
      class="noselect quantity-button-plus {{ inputClass }}"
      (click)="plus(product.multiplo)"
      >+
    </a>
  </div>
  <div
    class="input-group col-xl-6 col-lg-6 col-md-6 col-sm-6 col-3"
    [style.height.px]="produtoDescrHeight"
  >
    <button
      (mouseover)="hovered = true"
      (mouseout)="hovered = false"
      (click)="addCart()"
      class="btn confirm-button"
      [style.color]="theme.color"
      [style.border-color]="theme.color"
      [style.backgroundColor]="hovered ? theme.color : 'white'"
      type="button"
    >
      <i class="{{ SITE.iconCart }}"></i>
    </button>
  </div>
</div>
